<template>
  <div class="ImgShow">
    <v-container>
      <div class="bg_hot">
        <v-row>
          <v-col align="" style="position: relative">
            <div v-if="listTitle" class="backgroundImage">
              <div class="inline_title">
                <p class="txt">
                  {{ listTitle }}
                </p>
                <div class="inline_line"></div>
              </div>
            </div>
            <div class="video-container">
              <el-row>
                <div
                  v-for="(item, index) in classify ? getImgs : imgs[dataKey]"
                  :key="index"
                >
                  <el-col
                    :xs="12"
                    :sm="6"
                    :md="4"
                    :lg="4"
                    :xl="3"
                    v-if="item.img"
                  >
                    <div
                      class="grid-content bg-purple"
                      @click="goDetail(index)"
                    >
                      <a class="newsList_pic">
                        <img class="" :src="item.img" alt="" />
                      </a>
                      <div class="title">
                        {{ item.title }}
                      </div>
                    </div>
                  </el-col>
                </div>
              </el-row>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </div>
</template>
<script>
import imgs from "./ossImg";
// const animationData = require("./data.json");
// import Lottie from "./lottie.vue";

export default {
  components: {
    // lottie: Lottie
  },
  props: {
    listTitle: String,
    dataKey: String,
    classify: String,
  },
  data() {
    return {
      // defaultOptions: { animationData: animationData },
      imgs,
    };
  },
  computed: {
    getImgs() {
      return this.imgs[this.dataKey].filter(
        (item) => item.classify === this.classify
      );
    },
  },
  methods: {
    handleAnimation: function (anim) {
      this.anim = anim;
    },
    goDetail(index) {
      this.$router.push({
        query: {
          key: this.dataKey,
          idx: index,
        },
        path: "/introduce",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../base.scss";
.video-container {
  margin: 20px auto;
  //  width: vw(1200px);
  height: 300px;
}

.video {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  margin: 0 10px 20px;
  border-radius: 4px;
  position: relative;
  .title {
    height: 52px;
    font-size: 1rem;
    padding-top: 8px;
    background: #fff;
    cursor: pointer;
  }
}
.row-bg {
  background-color: #f9fafc;
}

.backgroundImage {
  // margin-top: 100px;
  margin-top: 60px;
}

.home .container {
  max-width: 100% !important;
  padding: 0;
  overflow: hidden;
}
.Header {
  width: 100%;
  text-align: center;
  height: vh(680px);
  position: relative;
}

.inline_title {
  width: vw(185px);
  text-align: center;
}

.inline_title .txt {
  margin-top: vh(50px);
  color: #343333;
  font-size: fz(28px);
  height: vh(50px);
  line-height: vh(50px);
  font-weight: Semibold;
  font-family: "苹方-简 中粗体";
  background-size: 100% 100%;
  background-image: url("../../assets/main_title_180x46.png");
}

.ImgShow {
  .newsList_pic {
    display: block;
    width: 100%;
    height: 240px;
    overflow: hidden;
    text-align: center;
  }
  .newsList_pic img {
    width: 100%;
    height: 100%;
    transition: all 0.3s;
    cursor: pointer;
  }
  .newsList_pic img:hover {
    transform: scale(1.1);
  }
}
</style>
